import React from "react";
import "../../Template02/Combined.css";
import { Link } from "react-router-dom";
import {
  FaPhoneAlt,
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
} from "react-icons/fa";
import { MdLocationPin } from "react-icons/md";
import { IoMail } from "react-icons/io5";

function Footer() {
  return (
    <>
      <footer
        className="footerBefore wb-footer wb-footer theme-dark-color-11"
        style={{
          position: "relative",
          backgroundSize: "cover",
          marginTop: "0px",
          paddingTop: "40px",
          paddingBottom: "20px",
        }}
      >
        <div className="container boxWidget">
          <div className="footer-content">
            <div className="row">
              {/* About Us Section */}
              <div className="col-lg-4 col-md-6 col-sm-12 mb-4">
                <div className="footer-logo">
                  <div className="richTextWidget">
                    <Link to="#" className="footer-link">
                      <h5>About Medisol Labs</h5>
                    </Link>
                    {/* <p style={{ fontSize: "14px", color: "#fff" }}>
                      At Medisol-Labs, we are at the forefront of revolutionizing
                      healthcare by designing and delivering state-of-the-art
                      medical technologies. Our focus is on crafting innovative
                      medical devices and solutions that improve the lives of
                      patients worldwide. With a commitment to quality and
                      compliance, we partner with healthcare professionals to
                      create cutting-edge solutions that cater to the evolving
                      needs of modern healthcare.
                    </p> */}
                    <p>
                      Medisol features a state-of-the-art facility with
                      cutting-edge technology, supporting complex research
                      endeavors. Our expert, multidisciplinary team of
                      passionate scientists drives innovation across diverse
                      fields. Committed to excellence, every formulation
                      undergoes stringent quality checks, ensuring compliance
                      with industry standards and best practices, delivering
                      reliable and pioneering solutions in research and
                      development.
                    </p>
                    {/* <ul style={{ color: "#fff" }}>
                      <li
                        style={{
                          listStyle: "none",
                          fontWeight: "600",
                          marginTop: "10px",
                        }}
                      >
                        State-of-the-Art Facility :
                      </li>
                      <li style={{ listStyle: "none", fontWeight: "300" }}>
                        Equipped with cutting-edge technology to support complex
                        research endeavors.
                      </li>
                      <li
                        style={{
                          listStyle: "none",
                          fontWeight: "600",
                          marginTop: "10px",
                        }}
                      >
                        Expert Team :
                      </li>
                      <li style={{ listStyle: "none", fontWeight: "300" }}>
                        Our multidisciplinary team of scientists and researchers
                        bring diverse expertise and a passion for innovation.
                      </li>
                      <li
                        style={{
                          listStyle: "none",
                          fontWeight: "600",
                          marginTop: "10px",
                        }}
                      >
                        Commitment to Quality :
                      </li>
                      <li style={{ listStyle: "none", fontWeight: "300" }}>
                        Every formulation undergoes stringent quality checks to
                        ensure compliance with industry standards and best
                        practices.
                      </li>
                    </ul> */}
                  </div>
                </div>
              </div>

              {/* Quick Links Section */}
              <div className="col-lg-4 col-md-6 col-sm-12 mb-4"style={{display:"flex",flexDirection:"column"}}>
                <div className="footer-links">
                  <h5 style={{ color: "#fff" }}>Quick Links</h5>
                  <ul>
                    <li>
                      <Link
                        to="/about"
                        style={{ fontSize: "14px" }}
                      >
                        About
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/services"
                        style={{fontSize: "14px" }}
                      >
                        Services
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="https://www.medisol.in/"
                        style={{fontSize: "14px" }}
                      >
                        Manufacturing
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>

               {/* Contact Information Section */}
               <div className="col-lg-4 col-md-6 col-sm-12 mb-4">
                <div className="footer-links">
                  <h5 style={{ color: "#fff" }}>Contact Information</h5>
                  <ul>
                    <li style={{display:"flex", textAlign: "start"}}>
                      <span className="fa">
                        <MdLocationPin />
                      </span>
                      <Link to="#" style={{  fontSize: "14px"}}>
                      Medisol labs Pvt. Ltd. <br/> is a inhaler formulation pharmaceutical unit  located at Aklara, Tal. Umargam Dist.Valsad (Gujarat), India.
                      </Link>
                    </li>

                    <li>
                      <span className="fa">
                        <FaPhoneAlt />
                      </span>
                      <Link
                        to="tel:+912269074440"
                        style={{ fontSize: "14px" }}
                      >
                         +91 2269074440
                      </Link>
                    </li>
                    <li >
                      <span className="fa">
                        {/* <IoMail /> */}
                      </span>
                      <Link
                        to="mailto:support@medisol-lab.com"
                        style={{fontSize: "14px" }}
                      >
                        {/* support@medisol-lab.com */}
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container boxWidget">
          <div className="footer-copyright">
            <div className="row">
              {/* Footer Text */}
              <div className="richTextWidget col-lg-8 col-md-8 col-sm-12 mb-4">
                <p style={{ color: "#fff" }}>
                  Copyright 2024 All Rights Reserved. Designed and Developed by{" "}
                  <span style={{ color: "#d10f56", fontWeight: "800" }}>
                    Medisol Labs
                  </span>
                </p>
              </div>

              {/* Social Media Links */}
              <div className="socialIconsWidget col-lg-4 col-md-4 col-sm-12 mb-4">
                <ul className="editSocialIcon">
                  <li style={{ marginRight: "15px" }}>
                    <a
                      href="https://www.facebook.com/MedisolLab"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "#d10f56" }}
                    >
                      <FaFacebookF />
                    </a>
                  </li>
                  <li style={{ marginRight: "15px" }}>
                    <a
                      href="https://www.twitter.com/MedisolLab"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "#d10f56" }}
                    >
                      <FaTwitter />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.linkedin.com/company/medisol-lab"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "#d10f56" }}
                    >
                      <FaLinkedinIn />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
